import { render, staticRenderFns } from "./Easter_defaultSection.vue?vue&type=template&id=9b320610&scoped=true"
import script from "./Easter_defaultSection.vue?vue&type=script&lang=ts"
export * from "./Easter_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./Easter_defaultSection.vue?vue&type=style&index=0&id=9b320610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b320610",
  null
  
)

export default component.exports